import GeneralLayout from "@/layouts/General"
import GreekHero from "@/components/GreekHero"
import Slider from "react-slick"
import { galleryImgs } from "@/app/utils/constants"
import CenteredHero from "@/components/CenteredHero"
import GreekLine from "@/components/GreekLine"
import ImgSlider from "./components/ImgSlider"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import ContentMAPI from "@/app/api/content-management/content-management"
import { useGlobalContext } from "@/global/GlobalContext"
import "@/assets/css/gallery.css"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import HeroSlider from "@/components/slider/HeroSlider"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import "@/assets/css/popup-image.css"
import GalleryBorderSkeleton from "@/components/skeletons/GalleryBorderSkeleton"
import clsx from "clsx"
const contentMApi = new ContentMAPI()

const Gallery = () => {
  const { notifyError } = useGlobalContext()
  const [galleries, setGalleries] = useState([])
  const [currGalleries, setCurrGalleries] = useState([])
  const [galleryImgsColl, setGalleryImgsColl] = useState([])
  const [selectedDisplay, setSelectedDisplay] = useState("")
  const [currSelected, setCurrSelected] = useState(null)
  const [currSelectedBorderImg, setCurrSelectedBorderImg] = useState(null)
  const [currSelectedCaption, setCurrSelectedCaption] = useState(null)
  const [popUp, setPopUp] = useState(false)
  const [selectedID, setSelectedID] = useState(null)
  const [currWindowWidth, setCurrWindowWidth] = useState(window.innerWidth)
  const [onReq, setOnReq] = useState(true)
  const gallerySection = useRef(null)
  const settings = {
    dots: true,
    infinite: true,
    speed: 2100,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2100,
    fade: true
  };

  const settings2 = {
    dots: false,
    infinite: true,
    centerMode: false,
    speed: 2100,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        // this breakpoints starts from the initial value to less
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          autoplay: true,
        }
      },
    ]
  };

  useEffect(() => {
    const handleResize = () => {
      setCurrWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
  }, [currWindowWidth])

  useEffect(() => {
    getGalleries()
  }, [])

  useLayoutEffect(() => {
    if (!!galleries.length) {
      handleGalleries(galleries)
    }
  }, [galleries])

  useLayoutEffect(() => {
    if (!galleryImgsColl.length && !!galleries.length) slideToGallSec(selectedDisplay)
  }, [galleryImgsColl])

  const slideToGallSec = name => {
    const selected = galleries.find(val => val.name == name)
    setGalleryImgsColl(selected.photos)
  }

  const handleSelectedDisplay = name => {
    setGalleryImgsColl([])
    setSelectedDisplay(name)
  }

  const handleGalleries = (arr) => {
    if (currWindowWidth < 1024) {
      const removeLast = arr.pop()
      arr.unshift(removeLast)
    }

    const currData = arr.map((obj, i) => ({
      ...obj,
      hasBorder: i != arr.length - 1
    }))

    setCurrGalleries(currData)
  }

  const scaleUpImg = (selectedId) => {
    const selectedImg = document.getElementById(`${selectedId}`)
    const bgShadow = document.getElementById("bgShadow")
    const selectedBorderImg = document.getElementById(`border-${selectedId}`)
    const imgRectW = selectedImg.getBoundingClientRect()
    const imgRectH = selectedImg.getBoundingClientRect();

    gallerySection.current.scrollIntoView({
      "behavior": "smooth"
    })
    if (selectedId == "image2") {
      if (currWindowWidth >= 1024) {
        selectedImg.classList.toggle("h-full")
        selectedImg.classList.toggle("h-[60%]")
      }
    } else if (selectedId == "image3" || selectedId == "image8" || selectedId == "image8--desktop") {
      if (currWindowWidth < 1024) {
        selectedImg.classList.toggle("w-full")
        selectedImg.classList.toggle("w-[40%]")
      }
    }

    if (!currSelected) {
      selectedImg.classList.toggle("gallery--scale-up")
      selectedBorderImg.style.width = `${imgRectW.width * 2}px`;
      selectedBorderImg.style.height = `${imgRectH.height * 2}px`;
      selectedBorderImg.classList.toggle("z-20")
      selectedBorderImg.classList.toggle("gallery__centered-image")
    }

    bgShadow.classList.toggle("real-hidden")
    setPopUp(!popUp)

    if (currSelected) {
      currSelected.classList.toggle("gallery--scale-up")
      currSelectedBorderImg.style = null;
      currSelectedBorderImg.classList.toggle("z-20")
      currSelectedBorderImg.classList.toggle("gallery__centered-image")

      if (currSelected != selectedImg) {
        selectedImg.classList.toggle("gallery--scale-up")
        selectedBorderImg.style.width = `${imgRectW.width * 2}px`;
        selectedBorderImg.style.height = `${imgRectH.height * 2}px`;
        selectedBorderImg.classList.toggle("z-20")
        selectedBorderImg.classList.toggle("gallery__centered-image")
        // if (selectedCaption) {
        //   selectedCaption.classList.toggle("real-hidden")
        //   selectedCaption.classList.toggle("bigger-text")
        // }
        // if (selectedCaptionBase) selectedCaptionBase.classList.toggle("real-hidden")
      } else if (currSelected == selectedImg) {
        setCurrSelected(null)
        setSelectedID(null)
        // setCurrSelectedBorderImg(null)
        // setCurrSelectedCaption(null)
        // setCurrSelectedCaptionBase(null)
        return
      }
    }

    setCurrSelected(selectedImg)
    setSelectedID(selectedId)
    setCurrSelectedBorderImg(selectedBorderImg)
    // if (selectedCaption) setCurrSelectedCaption(selectedCaption)
  }

  const onClickBgShadow = () => {
    currSelected.classList.toggle("gallery--scale-up")
    currSelectedBorderImg.classList.toggle("z-20")
    currSelectedBorderImg.classList.toggle("gallery__centered-image")
    bgShadow.classList.toggle("real-hidden")
    currSelectedBorderImg.style = null;
    setPopUp(!popUp)

    if (selectedID == "image2") {
      if (currWindowWidth >= 1024) {
        currSelected.classList.toggle("h-full")
        currSelected.classList.toggle("h-[60%]")
      }
    } else if (selectedID == "image3" || selectedID == "image8" || selectedID == "image8--desktop") {
      if (currWindowWidth < 1024) {
        currSelected.classList.toggle("w-full")
        currSelected.classList.toggle("w-[40%]")
      }
    }

    setCurrSelected(null)
    setSelectedID(null)
    setCurrSelectedBorderImg(null)
    // setCurrSelectedCaption(null)
    // setCurrSelectedCaptionBase(null)
  }

  // API request
  const getGalleries = async () => {
    setOnReq(true)
    try {
      const { data } = await contentMApi.getGalleries()
      setGalleries(data.data.galleries)
      if (data.data.galleries.length > 0) setGalleryImgsColl(data.data.galleries[0].photos)
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-transparent" hasGreekL={false} contentColor="text-white" relativeCls="relative -top-[50px] z-20">
        <GreekHero>
          <div className="relative">
            <HeroSlider settings={settings} slides={galleryImgs.slides} />
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-full">
              <h1 className="text-white text-center font-light text-5xl sm:text-6xl lg:text-7xl">
                <span className="uppercase font-agcasmlt text-center">di sini di sana</span>
                <span className="font-sloopScriptPro max-sm:block text-center"> Gallery</span>
              </h1>
            </div>
          </div>
        </GreekHero>
        <div className="pt-12 sm:pt-14 pb-4 sm:pb-6">
          {onReq ?
            <>
              <div className="flex">
                {Array.from({ length: currWindowWidth >= 1024 ? 3 : 2 }, (_, i) => (
                  <div key={i} className="pb-20 w-full">
                    <div className="px-5 sm:px-10 lg:px-20">
                      <div className="flex justify-between items-start">
                        <div className="w-[87%]">
                          <ContainerSkeleton custH="h-[24px] sm:h-[30px]" custCls="mb-1" />
                        </div>
                        <div className="w-[13%]">
                          <ContainerSkeleton />
                        </div>
                      </div>
                      <div className="w-full h-24 sm:h-36 md:h-44 lg:h-40 mb-2 sm:mb-4 flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton isDarker custCls="h-full w-full" />
                      </div>
                      <ContainerSkeleton custH="h-4 sm:h-5" />
                    </div>
                  </div>
                ))}
              </div>
            </>
            :
            currGalleries.length > 0 ?
              <Slider {...settings2} className="galleryDisplay">
                {currGalleries.map((s, i) => (
                  <div key={i}>
                    <ImgSlider custCls={(currWindowWidth >= 1024 && !s.hasBorder) ? "" : "border-e-[1px] border-charcoal-black"} title={s?.name} imgPath={s?.photos[3]} subtitle={s.subtitle} targetId="#gallerySection" handleSlide={() => handleSelectedDisplay(s?.name)} />
                  </div>
                ))}
              </Slider>
              :
              <p className="text-center text-gray-500">No gallery available.</p>
          }
        </div>
        <CenteredHero noTitle title="“Love is the foundation that builds beautiful legacies”" custTitleCls="capitalize font-americanTC text-2xl sm:text-3xl" custCls="bg-[url('/src/assets/imgs/gallery/banner.jpg')] h-[50vh] w-full relative" />
        <GreekLine custCls="top-1 relative w-full" />
        <section ref={gallerySection} id="gallerySection" className="bg-[url('/src/assets/imgs/our-story/the-loro-blonyo/section-cover.jpg')] bg-center bg-cover no-repeat py-16 mt-6 relative overflow-y-hidden">
          <div className="text-center">
            <span className="text-[40px] sm:text-[54px] text-[#6d625a] font-light"><span className="uppercase font-agcasmlt">di sini di sana</span><span className="font-sloopScriptPro"> Gallery</span></span>
          </div>
          {onReq ?
            <>
              <div className="grid grid-rows-3 lg:grid-rows-2 lg:grid-cols-2 gap-5 mt-12 container--gallery-img">
                <div className="grid grid-cols-2 gap-5 w-full container__gallery-img__child">
                  <div className="grid grid-rows-2 gap-[18px]">
                    <div className="w-full h-full flex items-center justify-center overflow-hidden">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                    <div className="w-full h-full flex items-center justify-center overflow-hidden">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                  </div>
                  <div className="h-full">
                    <div className="w-full h-full flex items-center justify-center overflow-hidden">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                  </div>
                </div>
                {/* photos 2 */}
                <div className="h-[calc(300px-10px)] sm:h-[calc(500px-10px)]">
                  <div className="grid grid-rows-2 gap-5 w-full ">
                    <div className="w-full flex items-center justify-center overflow-hidden h-[calc(150px-10px)] sm:h-[calc(250px-10px)]">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                    <div className="grid grid-cols-2 gap-[18px] h-[calc(150px-10px)] sm:h-[calc(250px-10px)]">
                      <div className="w-full h-full flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton custCls="h-full w-full object-cover object-center" />
                      </div>
                      <div className="w-full h-full flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton custCls="h-full w-full object-cover object-center" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* for mobiles and tables */}
                <div className="h-[calc(300px-10px)] sm:h-[calc(500px-10px)] lg:hidden">
                  <div className="grid lg:hidden grid-rows-2 gap-5 w-full">
                    <div className="grid grid-cols-2 gap-[18px]">
                      <div className="w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton custCls="h-full w-full object-cover object-center" />
                      </div>
                      <div className="w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton custCls="h-full w-full object-cover object-center" />
                      </div>
                    </div>
                    <div className="w-full">
                      <div className="w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                        <ContainerSkeleton custCls="h-full w-full object-cover object-center" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* for desktop */}
                <div className="grid max-lg:hidden grid-cols-2 gap-5 container__gallery-img__child2">
                  <div>
                    <div className="w-full h-full flex items-center justify-center overflow-hidden">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                  </div>
                  <div>
                    <div className="w-full h-full flex items-center justify-center overflow-hidden">
                      <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                    </div>
                  </div>
                </div>
                <div className="max-lg:hidden w-full h-[250px]">
                  <div className="w-full h-full flex items-center justify-center overflow-hidden">
                    <ContainerSkeleton custCls="w-full h-full object-cover object-center" />
                  </div>
                </div>
              </div>
            </>
            :
            currGalleries.length > 0 ?
              <>
                <div id="bgShadow" onClick={onClickBgShadow} className="h-full w-full z-10 top-0 absolute transition-opacity real-hidden bg-shadow"></div>
                <div className="grid grid-rows-3 lg:grid-rows-2 lg:grid-cols-2 gap-5 mt-12 container--gallery-img gallery-content relative px-10">
                  <div className="grid grid-cols-2 gap-5 w-full container__gallery-img__child">
                    <div className="grid grid-rows-2 gap-[18px]">
                      {selectedID == "image0" && <GalleryBorderSkeleton />}
                      <div id="border-image0" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                        <ImageSkeleton src={galleryImgsColl[0]} id="image0" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="w-full h-full object-cover object-center cursor-pointer" />
                      </div>
                      {selectedID == "image1" && <GalleryBorderSkeleton />}
                      <div id="border-image1" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                        <ImageSkeleton src={galleryImgsColl[1]} id="image1" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="w-full h-full object-cover object-center cursor-pointer" />
                      </div>
                    </div>
                    <div className="h-full">
                      {selectedID == "image2" && <GalleryBorderSkeleton />}
                      <div id="border-image2" className="relative w-full h-full flex justify-center overflow-hidden">
                        <ImageSkeleton src={galleryImgsColl[2]} id="image2" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls={clsx("w-full h-full object-cover object-center cursor-pointer")} />
                      </div>
                    </div>
                  </div>
                  {/* photos 2 */}
                  <div className="h-[calc(300px-10px)] sm:h-[calc(500px-10px)]">
                    <div className="grid grid-rows-2 gap-5 w-full ">
                      {selectedID == "image3" && <GalleryBorderSkeleton />}
                      <div id="border-image3" className="relative w-full flex items-center justify-center overflow-hidden h-[calc(150px-10px)] sm:h-[calc(250px-10px)]">
                        <ImageSkeleton src={galleryImgsColl[3]} id="image3" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="w-full h-full object-cover object-center cursor-pointer" />
                      </div>
                      <div className="grid grid-cols-2 gap-[18px] h-[calc(150px-10px)] sm:h-[calc(250px-10px)]">
                        {selectedID == "image4" && <GalleryBorderSkeleton />}
                        <div id="border-image4" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                          <ImageSkeleton src={galleryImgsColl[4]} id="image4" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative h-full w-full object-cover object-center cursor-pointer" />
                        </div>
                        {selectedID == "image5" && <GalleryBorderSkeleton />}
                        <div id="border-image5" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                          <ImageSkeleton src={galleryImgsColl[5]} id="image5" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative h-full w-full object-cover object-center cursor-pointer" />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* for mobiles and tables */}
                  <div className="h-[calc(300px-10px)] sm:h-[calc(500px-10px)] lg:hidden">
                    <div className="grid lg:hidden grid-rows-2 gap-5 w-full">
                      <div className="grid grid-cols-2 gap-[18px]">
                        {selectedID == "image6" && <GalleryBorderSkeleton />}
                        <div id="border-image6" className="relative w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                          <ImageSkeleton src={galleryImgsColl[6]} id="image6" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative h-full w-full object-cover object-center cursor-pointer" />
                        </div>
                        {selectedID == "image7" && <GalleryBorderSkeleton />}
                        <div id="border-image7" className="relative w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                          <ImageSkeleton src={galleryImgsColl[7]} id="image7" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative h-full w-full object-cover object-center cursor-pointer" />
                        </div>
                      </div>
                      <div className="w-full">
                        {selectedID == "image8" && <GalleryBorderSkeleton />}
                        <div id="border-image8" className="relative w-full h-[calc(150px-10px)] sm:h-[calc(250px-10px)] flex items-center justify-center overflow-hidden">
                          <ImageSkeleton src={galleryImgsColl[8]} id="image8" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative h-full w-full object-cover object-center cursor-pointer" />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* for desktop */}
                  {/* TODO: perlu perbaikan, gambar muncul di area bawah, bukan tengah" */}
                  <div className="grid max-lg:hidden grid-cols-2 gap-5 container__gallery-img__child2">
                    <div>
                      {selectedID == "image6--desktop" && <GalleryBorderSkeleton />}
                      <div id="border-image6--desktop" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                        <ImageSkeleton src={galleryImgsColl[6]} id="image6--desktop" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative w-full h-full object-cover object-center cursor-pointer" />
                      </div>
                    </div>
                    <div>
                      {selectedID == "image7--desktop" && <GalleryBorderSkeleton />}
                      <div id="border-image7--desktop" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                        <ImageSkeleton src={galleryImgsColl[7]} id="image7--desktop" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative w-full h-full object-cover object-center cursor-pointer" />
                      </div>
                    </div>
                  </div>
                  <div className="max-lg:hidden w-full h-[250px]">
                    {selectedID == "image8--desktop" && <GalleryBorderSkeleton />}
                    <div id="border-image8--desktop" className="relative w-full h-full flex items-center justify-center overflow-hidden">
                      <ImageSkeleton src={galleryImgsColl[8]} id="image8--desktop" hasEvent scaleUpImg={(id) => scaleUpImg(id)} custCls="relative w-full h-full object-cover object-center cursor-pointer" />
                    </div>
                  </div>
                </div>
              </>
              :
              <p className="text-center text-gray-500">No gallery available.</p>
          }
        </section>
      </GeneralLayout>
    </>
  )
}

export default Gallery